// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://wqsgfikkgordacsftghh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Indxc2dmaWtrZ29yZGFjc2Z0Z2hoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc3NTk0NjUsImV4cCI6MjA2MzMzNTQ2NX0.i3omgd8pUYjtvZAv9FBz38vA8zGT5nYaCcP9_wFcXUo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);